import { Injectable } from '@angular/core'
import * as signalR from '@microsoft/signalr'
import { Subject } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { AuthService } from '../auth/auth.service'

export interface LinhaAtualizadaEvent {
  osId: string
  motivo: string
}

// Canal ao vivo da Torre. O evento é só um aviso — "OsAtualizada" carrega
// osId + motivo, não a linha pronta (contrato real capturado no qa, sprint
// 9/10 seção 03); quem assina reconsulta. O socket não avisa mudança de cor
// por tempo (isso o front resolve sozinho com alertaEm/criticoEm); ele só
// carrega evento de verdade: alguém confirmou, alguém registrou, alguém
// trocou o motorista.
@Injectable({
  providedIn: 'root',
})
export class MonitoringHubService {
  private connection: signalR.HubConnection | null = null
  private assinaturaAtual: string | null = null

  public linhaAtualizada$ = new Subject<LinhaAtualizadaEvent>()

  constructor(private authService: AuthService) {}

  async start(): Promise<void> {
    if (this.connection) return

    // baseUrl termina em '/api/'; o hub fica na raiz do host — o token vai na
    // query porque o WebSocket do navegador não permite cabeçalhos na abertura.
    const hubUrl = `${environment.baseUrl.replace(/api\/?$/, '')}hubs/monitoramento`

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, { accessTokenFactory: () => this.authService.getToken() ?? '' })
      .withAutomaticReconnect()
      .build()

    this.connection.on('OsAtualizada', (osId: string, motivo: string) => {
      this.linhaAtualizada$.next({ osId, motivo })
    })

    // Reassina o dia em vigor no reconnect — a inscrição não sobrevive à queda.
    this.connection.onreconnected(() => {
      if (this.assinaturaAtual) this.connection?.invoke('Assinar', this.assinaturaAtual)
    })

    await this.connection.start()
  }

  async assinar(dia: string): Promise<void> {
    await this.start()
    if (this.assinaturaAtual === dia) return
    if (this.assinaturaAtual) await this.cancelar(this.assinaturaAtual)
    this.assinaturaAtual = dia
    await this.connection?.invoke('Assinar', dia)
  }

  async cancelar(dia: string): Promise<void> {
    if (this.assinaturaAtual === dia) this.assinaturaAtual = null
    await this.connection?.invoke('Cancelar', dia)
  }

  async stop(): Promise<void> {
    if (this.assinaturaAtual) await this.cancelar(this.assinaturaAtual)
    await this.connection?.stop()
    this.connection = null
  }
}
